// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-hamburger-screen-layout {
  display: flex;
  flex-direction: column;
  /* align-items: flex-start; */
  justify-content: flex-start;
  height:100%;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.default-menu-items-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;

}

.default-menu-header-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: flex-end;
  align-items: center;
}

.default-view-action-items-container {
  margin-bottom: 10px;
  display: flex;
  flex: 1 1;
  align-items: center;
  /* background-color: antiquewhite; */
  flex-direction: column;
  gap: 10px;
  margin-left: 5px;
  margin-right: 5px;
}

.default-menu-thanks-container {
  margin: 10px;
}
.default-menu-spacer {
  flex:2 1;
}
.default-view-action-item-container {
  display: flex;
  flex-direction: column;
  flex:1 1;
  width: 95%;
  border-radius: 2px;
  border-color: darkgray;
  border-width: thin;
  border-style: solid;
}

`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/pages/Default/Default.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;;AAEX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,QAAM;AACR;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAM;EACN,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".default-hamburger-screen-layout {\n  display: flex;\n  flex-direction: column;\n  /* align-items: flex-start; */\n  justify-content: flex-start;\n  height:100%;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n.default-menu-items-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 10px;\n\n}\n\n.default-menu-header-container {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.default-view-action-items-container {\n  margin-bottom: 10px;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  /* background-color: antiquewhite; */\n  flex-direction: column;\n  gap: 10px;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.default-menu-thanks-container {\n  margin: 10px;\n}\n.default-menu-spacer {\n  flex:2;\n}\n.default-view-action-item-container {\n  display: flex;\n  flex-direction: column;\n  flex:1;\n  width: 95%;\n  border-radius: 2px;\n  border-color: darkgray;\n  border-width: thin;\n  border-style: solid;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
